module.exports = __webpack_public_path__ + "media/PAG82-06.11a64d6e.mp3";